import { useCallback, useEffect, useRef, useState } from 'react'
import { normalizeEvent } from '../utils/events'

const ENDPOINT = 'https://eonet.gsfc.nasa.gov/api/v3/events'

// status=all et non status=open : les événements mondiaux (source GDACS) sont
// clôturés dès leur création par EONET, seuls les feux américains (IRWIN)
// restent "open". Filtrer sur open reviendrait à n'afficher que les États-Unis.
const buildUrl = days => `${ENDPOINT}?category=wildfires&status=all&days=${days}`

const INITIAL = { status: 'loading', events: [], error: null, fetchedAt: null }

export const useWildfires = days => {
    const [state, setState] = useState(INITIAL)
    const abortRef = useRef(null)

    const load = useCallback(async () => {
        abortRef.current?.abort()
        const controller = new AbortController()
        abortRef.current = controller

        setState(prev => ({ ...prev, status: 'loading', error: null }))

        try {
            const res = await fetch(buildUrl(days), { signal: controller.signal })
            if (!res.ok) throw new Error(`EONET a répondu ${res.status} ${res.statusText || ''}`.trim())

            const data = await res.json()
            const events = (data.events ?? [])
                .map(normalizeEvent)
                .filter(Boolean)
                .sort((a, b) => b.timestamp - a.timestamp)

            setState({ status: 'ready', events, error: null, fetchedAt: Date.now() })
        } catch (err) {
            // Une requête annulée (changement de période, démontage) n'est pas une erreur.
            if (err.name === 'AbortError') return
            setState({ status: 'error', events: [], error: err.message, fetchedAt: null })
        }
    }, [days])

    useEffect(() => {
        load()
        return () => abortRef.current?.abort()
    }, [load])

    return { ...state, reload: load }
}
